import React from 'react';

interface TipBoxProps {
  title: string;
  children: React.ReactNode;
}

const TipBox: React.FC<TipBoxProps> = ({ title, children }) => {
  return (
    <div className="tip-box">
      <h3>{title}</h3>
      {children}
    </div>
  );
};

export default TipBox;